module.exports = __webpack_public_path__ + "media/recipes/21-920e4b63.png";